import BasePageFilter from "@/domains/BasePageFilter/BasePageFilter";
import Person from "@/domains/Persons/Person";
import Core from "@/core/Core";

class ShipmentsPageFilter extends BasePageFilter {
  static Events = {
    Updated: 'shipments-registry-filter:updated',
  } as const;

  protected storageKey = 'filters:shipments-page';

  responsible: Person;

  private _isMine: boolean;

  get isMine(): boolean {
    return this._isMine;
  }

  set isMine(value: boolean) {
    this._isMine = value;

    if (value === true) {
      this.responsible = Core.currentUser;
    } else {
      this.responsible = undefined;
    }
  }

  reset(): void {
    if (this.isLocked('responsible') === false) {
      this.responsible = undefined;
    }
  }

  protected deserialize(json: string): void {
    const parsed = JSON.parse(json);

    if (this.isLocked('responsible') === false) {
      this.responsible = Core.utils.hydrate(parsed.responsible, Person.fromServer);
    }
  }

  getRequestParams(): Record<string, any> {
    const params: any = {};

    if (this.responsible?.id) {
      params.responsible = { id: this.responsible.id };
    }

    return params;
  }
}

export default ShipmentsPageFilter;
